import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Date created',
    sortable: false,
  },
  {
    name: 'organizationId',
    label: 'Customer',
    sortable: false,
  },
  {
    name: 'warningType',
    label: 'Warning type',
    sortable: false,
  },
  {
    name: 'warningEntity',
    label: 'Entity',
    sortable: false,
  },
  {
    name: 'type',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'actions',
    label: 'Action',
    sortable: false,
  },
  {
    name: 'employeeId',
    label: 'Resolved by',
    sortable: false,
  },
  {
    name: 'matchStatus',
    label: 'Matching status',
    sortable: false,
  },
  {
    name: 'blacklistId',
    label: 'Block List',
    sortable: false,
  },
  {
    name: 'riskScoreFrom',
    label: 'Risk score',
    sortable: false,
    filterModalPlacement: 'right',
  },
  {
    name: 'monitoringRuleId',
    label: 'Monitoring rule',
    sortable: false,
    filterModalPlacement: 'right',
  },
  {
    name: 'applicationId',
    label: 'Application',
    sortable: false,
  },
];

export const columnsLabels = {
  type: 'Type',
  warningEntity: 'Warning Entity',
  blacklistId: 'Block List',
  riskScoreFrom: 'Risk Score',
  createdAt: 'Date created',
  createdAtFrom: 'Date created From',
  createdAtTo: 'Date created To',
  organizationId: 'Customer',
  monitoringRuleId: 'Monitoring rule',
  actions: 'Action',
};

export const schema = {
  createdAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['createdAtFrom', 'createdAtTo'],
  },
  createdAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  createdAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  warningEntity: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  blacklistId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  monitoringRuleId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  riskScoreFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  organizationId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  organizationType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  transactionTypeId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  transactionPaymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentOrderType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  actions: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'organizationId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter Name or Company Name...',
  },
  {
    name: 'type',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'type',
        title: 'Blocklist',
        value: 'BLACKLIST',
      },
      {
        name: 'type',
        title: 'Scoring',
        value: 'SCORING',
      },
      {
        name: 'type',
        title: 'Monitoring',
        value: 'MONITORING',
      },
      {
        name: 'type',
        title: 'Agreement',
        value: 'AGREEMENT',
      },
      {
        name: 'type',
        title: 'Aml Bot',
        value: 'AML_BOT',
      },
    ],
  },
  {
    name: 'actions',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'actions',
        title: 'Stop',
        value: 'STOP',
      },
      {
        name: 'actions',
        title: 'Pass Once',
        value: 'PASS_ONCE',
      },
      {
        name: 'actions',
        title: 'Pass Combination',
        value: 'PASS_COMBINATION',
      },
      {
        name: 'actions',
        title: 'Pass all time for this client',
        value: 'PASS_ALL_TIME_FOR_THIS_CLIENT',
      },
      {
        name: 'actions',
        title: 'RFI to client docs',
        value: 'RFI_TO_CLIENT_DOCS',
      },
      {
        name: 'actions',
        title: 'RFI to client clarifications',
        value: 'RFI_TO_CLIENT_CLARIFICATIONS',
      },
    ],
  },

  {
    name: 'warningEntity',
    type: FilterType.RADIO,
    withClearButton: true,
    fields: [
      {
        name: 'warningEntity',
        title: 'Customer',
        value: 'ORGANIZATION',
      },
      {
        name: 'warningEntity',
        title: 'Application',
        value: 'APPLICATION',
      },
      {
        name: 'warningEntity',
        title: 'Transaction',
        value: 'TRANSACTION',
      },
      {
        name: 'warningEntity',
        title: 'Payment Order',
        value: 'PAYMENT_ORDER',
      },
    ],
  },
  {
    name: 'blacklistId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter blacklist...',
  },
  {
    name: 'monitoringRuleId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter monitoring rule...',
  },
  {
    name: 'riskScoreFrom',
    type: FilterType.TEXT,
    placeholder: 'Enter number...',
  },
  {
    name: 'createdAt',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
];
